import { render, staticRenderFns } from "./UserFeaturesTab.vue?vue&type=template&id=53f75d62&scoped=true&"
import script from "./UserFeaturesTab.vue?vue&type=script&lang=js&"
export * from "./UserFeaturesTab.vue?vue&type=script&lang=js&"
import style0 from "./UserFeaturesTab.vue?vue&type=style&index=0&id=53f75d62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f75d62",
  null
  
)

export default component.exports